import { FC, ReactNode } from "react";

import { AppHeader } from "./AppHeader";
import { ScreenLayout } from "./ScreenLayout";

type HeaderAndFooterLayoutPropsType = {
  children: ReactNode;
};

export const HeaderAndFooterLayout: FC<HeaderAndFooterLayoutPropsType> = ({
  children,
}) => {
  return (
    <>
      <AppHeader className="border-border border-b px-4 py-3" />
      <ScreenLayout>{children}</ScreenLayout>
    </>
  );
};
